/**
 * Mapeia cada periodicidade para o deslocamento em meses.
 *
 * @type {Record<string, number>}
 */
export const PERIODICIDADE_PARA_MESES = {
    Mensal: 1,
    Bimestral: 2,
    Trimestral: 3,
    Semestral: 6,
    Anual: 12,
};

/**
 * Opcoes de desconto exibidas nos formularios de recebivel.
 *
 * @type {{label: string, value: string}[]}
 */
export const DESCONTO_OPTIONS = [
    { label: 'Selecione', value: '0' },
    { label: 'PORCENTAGEM (%)', value: '%' },
    { label: 'REAL (R$)', value: 'R$' },
];
